module.exports = __webpack_public_path__ + "img/agricultural.cc6d6b8c.svg";